import Request from 'core/api/Request';

export const getter = async (url) => {
  const response = await Request.get(url);
  return response.body;
};

export const patch = async (url, data = {}) => {
  const response = await Request.patch(url).send(data);
  return response.body;
};

export const post = async (url, data = {}) => {
  const response = await Request.post(url).send(data);
  return response.body;
};
